
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
img {
      height:auto;
      width:100%;
}

.billboard-content-section {
      color:var(--neutral-white);
}

.billboard-eyebrow {
      margin-bottom:0.5rem;
      display:flex;
      flex-direction:column;
      gap:0.5rem;
}

@media (min-width: 1024px) {

      .billboard-eyebrow {
            gap:0.75rem;
      }
}

.billboard-headline {
      margin-bottom:0.875rem;
      font-weight:var(--fw-bold);
}

.billboard-sub-headline {
      margin-bottom:0.625rem;
}

.billboard-body-text {
      margin-bottom:0.875rem;
}

.billboard-cta {
      display:flex;
      flex-direction:column;
      gap:1.5rem;
}

.green-primary {
      background-color:var(--primary-green);
}

.neutral-lighter {
      background-color:var(--bh-neutral-lighter);
}

:host([site='GHS']) .blue-primary {
      background-color:var(--primary-blue);
}

:host([site='BH']) .blue-primary {
      background-color:var(--bh-brand-primary-default);
}

:host([billboardvariant='offset']) img {
      display:block;
}

:host([billboardvariant='offset']) .billboard {
      display:flex;
}

:host([billboardvariant='offset']) .billboard {
      width:100%;
}

:host([billboardvariant='offset']) .billboard {
      flex-direction:column;
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard {
            padding-bottom:16rem;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='offset']) .billboard {
            padding-bottom:6rem;
      }
}

:host([billboardvariant='offset']) .right-align .billboard-hero-image-wrapper {
      justify-content:flex-start;
}

:host([billboardvariant='offset']) .right-align .billboard-hero-image-wrapper{
      transform:translateX(-1.5rem);
    }

@media (min-width: 768px){

:host([billboardvariant='offset']) .right-align .billboard-hero-image-wrapper{
        transform:translateX(0)
    }
      }

:host([billboardvariant='offset']) .right-align .billboard-hero-image {
      border-top-right-radius:0.75rem;
      border-bottom-right-radius:0.75rem;
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .right-align .billboard-hero-image {
            margin-right:0px;
      }
}

:host([billboardvariant='offset']) .right-align .billboard-content-section {
      align-self:flex-end;
}

:host([billboardvariant='offset']) .right-align .billboard-content-section {
      border-top-left-radius:0.75rem;
      border-bottom-left-radius:0.75rem;
}

:host([billboardvariant='offset']) .right-align .billboard-content-section{
      margin-top:-20%;
      transform:translateX(1.5rem)
    }

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .right-align .billboard-content-section {
            right:0px;
      }
}

@media (min-width: 768px){

:host([billboardvariant='offset']) .right-align .billboard-content-section{
        transform:translateX(0)
    }
      }

:host([billboardvariant='offset']) .left-align .billboard-hero-image-wrapper {
      margin-right:-1.5rem;
}

:host([billboardvariant='offset']) .left-align .billboard-hero-image-wrapper {
      justify-content:flex-end;
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .left-align .billboard-hero-image-wrapper {
            margin-right:0px;
      }
}

:host([billboardvariant='offset']) .left-align .billboard-hero-image {
      border-top-left-radius:0.75rem;
      border-bottom-left-radius:0.75rem;
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .left-align .billboard-hero-image {
            margin-left:0px;
      }
}

:host([billboardvariant='offset']) .left-align .billboard-content-section {
      align-self:flex-start;
}

:host([billboardvariant='offset']) .left-align .billboard-content-section {
      border-top-right-radius:0.75rem;
      border-bottom-right-radius:0.75rem;
}

:host([billboardvariant='offset']) .left-align .billboard-content-section{
      transform:translate(0, 0);
      margin-top:-20%;
    }

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .left-align .billboard-content-section {
            left:0px;
      }
}

:host([billboardvariant='offset']) .billboard-inner {
      position:relative;
}

@media (min-width: 1024px) {

      :host([billboardvariant='offset']) .billboard-inner {
            margin-left:auto;
            margin-right:auto;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='offset']) .billboard-inner {
            width:83.333333%;
      }
}

:host([billboardvariant='offset']) .billboard-content-section {
      position:relative;
}

:host([billboardvariant='offset']) .billboard-content-section {
      z-index:20;
}

:host([billboardvariant='offset']) .billboard-content-section {
      box-sizing:border-box;
}

:host([billboardvariant='offset']) .billboard-content-section {
      padding:1.25rem;
}

:host([billboardvariant='offset']) .billboard-content-section{
    width:calc(100% - 1.5rem)
  }

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard-content-section {
            position:absolute;
      }
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard-content-section {
            bottom:-16rem;
      }
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard-content-section {
            margin-left:0px;
      }
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard-content-section {
            width:75%;
      }
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard-content-section {
            max-width:1024px;
      }
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard-content-section {
            border-radius:0.75rem;
      }
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard-content-section {
            padding:2.5rem;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='offset']) .billboard-content-section {
            bottom:-6rem;
      }
}

@media (min-width: 1280px) {

      :host([billboardvariant='offset']) .billboard-content-section {
            width:50%;
      }
}

@media (min-width: 768px){

:host([billboardvariant='offset']) .billboard-content-section{
      transform:translate(0, 0)
  }
    }

:host([billboardvariant='offset']) .billboard-hero-image-wrapper {
      display:flex;
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard-hero-image-wrapper {
            width:auto;
      }
}

:host([billboardvariant='offset']) .billboard-hero-image {
      max-width:100%;
}

:host([billboardvariant='offset']) .billboard-hero-image {
      overflow:hidden;
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard-hero-image {
            width:65%;
      }
}

@media (min-width: 768px) {

      :host([billboardvariant='offset']) .billboard-hero-image {
            border-radius:0.75rem;
      }
}

:host([billboardvariant='offset']) .billboard-hero-image{
    max-height:500px;
    min-height:250px;
  }

:host([billboardvariant='offset']) .billboard-body-text {
      margin-bottom:1.5rem;
}

:host([billboardvariant='offset']) .green-primary, :host([billboardvariant='offset']) .neutral-lighter, :host([billboardvariant='offset']):host([site='GHS']) .blue-primary, :host([billboardvariant='offset']):host([site='BH']) .blue-primary {
      background-color:var(--neutral-transparent);
}

:host([billboardvariant='offset']) .green-primary .billboard-content-section {
      background-color:var(--primary-green);
}

:host([billboardvariant='offset']) .neutral-lighter .billboard-content-section {
      background-color:var(--bh-neutral-lighter);
}

:host([billboardvariant='offset']):host([site='GHS']) .blue-primary .billboard-content-section {
      background-color:var(--primary-blue);
}

:host([billboardvariant='offset']):host([site='BH']) .blue-primary .billboard-content-section {
      background-color:var(--bh-brand-primary-default);
}

:host([billboardvariant='full']) :host {
      display:block;
}

@media (min-width: 1024px) {

      :host([billboardvariant='full']) :host {
            padding-top:2.5rem;
            padding-bottom:2.5rem;
      }
}

:host([billboardvariant='full']) .billboard-inner {
      display:flex;
}

:host([billboardvariant='full']) .billboard-inner {
      flex-direction:column;
}

:host([billboardvariant='full']) .billboard-inner {
      align-items:center;
}

:host([billboardvariant='full']) .billboard-inner {
      gap:1.5rem;
}

:host([billboardvariant='full']) .billboard-inner {
      padding-left:1.5rem;
      padding-right:1.5rem;
}

:host([billboardvariant='full']) .billboard-inner {
      padding-top:2rem;
      padding-bottom:2rem;
}

@media (min-width: 768px) {

      :host([billboardvariant='full']) .billboard-inner {
            flex-direction:column;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='full']) .billboard-inner {
            margin-top:2.5rem;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='full']) .billboard-inner {
            margin-bottom:2.5rem;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='full']) .billboard-inner {
            flex-direction:row;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='full']) .billboard-inner {
            padding-top:0px;
            padding-bottom:0px;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='full']) .billboard-hero-image-wrapper {
            margin-top:-2.5rem;
            margin-bottom:-2.5rem;
      }
}

:host([billboardvariant='full']) .billboard-hero-image-wrapper img {
      display:block;
}

:host([billboardvariant='full']) .billboard-hero-image-wrapper img {
      border-radius:0.75rem;
}

@media (min-width: 768px) {

      :host([billboardvariant='full']) .left-align .billboard-inner {
            flex-direction:column-reverse;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='full']) .left-align .billboard-inner {
            flex-direction:row-reverse;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='full']) .billboard-hero-image-wrapper, :host([billboardvariant='full']) .billboard-content-section {
            width:50%;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='full']) .billboard-content-section {
            padding-top:2rem;
            padding-bottom:2rem;
      }
}

:host([billboardvariant='full']) .billboard-body-text ::slotted(*), :host([billboardvariant='full']) .billboard-cta ::slotted(*) {
      text-align:left;
}

:host([billboardvariant='full']) .billboard-cta {
      font-weight:var(--fw-semibold);
}

:host([billboardvariant='feature']) .billboard-inner {
      display:flex;
}

:host([billboardvariant='feature']) .billboard-inner {
      flex-direction:column;
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .right-align .billboard-inner {
            flex-direction:row;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .left-align .billboard-inner {
            flex-direction:row-reverse;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .billboard-hero-image-wrapper {
            flex-basis:50%;
      }
}

:host([billboardvariant='feature']) [slot='billboard-hero-image'] div, :host([billboardvariant='feature']) .billboard-hero-image, :host([billboardvariant='feature']) ::slotted(*) {
      height:100%;
}

:host([billboardvariant='feature']) [slot='billboard-hero-image'] div, :host([billboardvariant='feature']) .billboard-hero-image, :host([billboardvariant='feature']) ::slotted(*) {
      width:100%;
}

:host([billboardvariant='feature']) [slot='billboard-hero-image'] div img, :host([billboardvariant='feature']) .billboard-hero-image img, :host([billboardvariant='feature']) ::slotted(*) img {
      height:100%;
}

:host([billboardvariant='feature']) [slot='billboard-hero-image'] div img, :host([billboardvariant='feature']) .billboard-hero-image img, :host([billboardvariant='feature']) ::slotted(*) img {
      width:100%;
}

:host([billboardvariant='feature']) [slot='billboard-hero-image'] div img, :host([billboardvariant='feature']) .billboard-hero-image img, :host([billboardvariant='feature']) ::slotted(*) img {
      object-fit:cover;
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .billboard-content-wrapper {
            display:flex;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .billboard-content-wrapper {
            flex-basis:50%;
      }
}

:host([billboardvariant='feature']) .billboard-content-section {
      margin:1rem;
}

:host([billboardvariant='feature']) .billboard-content-section {
      border-radius:0.75rem;
}

:host([billboardvariant='feature']) .billboard-content-section {
      padding-left:1rem;
      padding-right:1rem;
}

:host([billboardvariant='feature']) .billboard-content-section {
      padding-top:2rem;
      padding-bottom:2rem;
}

@media (min-width: 768px) {

      :host([billboardvariant='feature']) .billboard-content-section {
            margin:1.5rem;
      }
}

@media (min-width: 768px) {

      :host([billboardvariant='feature']) .billboard-content-section {
            padding-left:1.5rem;
            padding-right:1.5rem;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .billboard-content-section {
            margin:3rem;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .billboard-content-section {
            display:flex;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .billboard-content-section {
            flex-direction:column;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .billboard-content-section {
            justify-content:center;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .billboard-content-section {
            padding-left:3rem;
            padding-right:3rem;
      }
}

@media (min-width: 1024px) {

      :host([billboardvariant='feature']) .billboard-content-section {
            padding-top:5rem;
            padding-bottom:5rem;
      }
}

@media (min-width: 1280px) {

      :host([billboardvariant='feature']) .billboard-content-section {
            padding:5rem;
      }
}

:host([billboardvariant='feature']):host([border]) .billboard-content-section {
      border-width:1px;
}

:host([billboardvariant='feature']):host([border]) .billboard-content-section {
      border-style:solid;
}

:host([billboardvariant='feature']) .billboard-eyebrow {
      font-weight:var(--fw-bold);
}

:host([billboardvariant='feature']) .billboard-headline {
      margin-bottom:1rem;
}

:host([billboardvariant='feature']) .billboard-headline {
      font-weight:var(--fw-light);
}

:host([billboardvariant='feature']) .billboard-sub-headline {
      margin-bottom:1rem;
}

:host([billboardvariant='feature']) .billboard-body-text {
      margin-bottom:1.75rem;
}

:host([billboardvariant='feature']) .green-primary .billboard-content-section {
      border-color:var(--primary-green-light-1);
}

:host([billboardvariant='feature']) .neutral-lighter .billboard-content-section {
      border-color:var(--bh-neutral-default);
}

:host([billboardvariant='feature']) .neutral-lighter .billboard-content-section {
      color:var(--bh-neutral-darker);
}

:host([billboardvariant='feature']) .neutral-lighter .billboard-eyebrow {
      color:var(--bh-brand-primary-default-compatibility);
}

:host([billboardvariant='feature']):host([site='GHS']) .blue-primary .billboard-content-section {
      border-color:var(--primary-blue-light-1);
}

:host([billboardvariant='feature']):host([site='BH']) .blue-primary .billboard-content-section {
      border-color:var(--bh-brand-primary-light);
}

:host([site='BH']) .billboard-content-section {
      font-family:var(--bh-ff-body);
}

:host([site='BH']) .billboard-content-section ::slotted(*) {
      font-family:var(--bh-ff-body);
}

:host([site='BH']) .billboard-content-section .billboard-sub-headline ::slotted(*) {
      font-family:var(--bh-ff-display);
}

:host([site='BH']) .billboard-content-section .billboard-sub-headline ::slotted(*) {
      font-size:var(--bh-fs-heading-04);
      line-height:var(--bh-lh-heading-04);
      letter-spacing:var(--bh-ls-heading-04);
}

:host([site='BH']) .billboard-headline {
      font-size:var(--bh-fs-heading-06);
      line-height:var(--bh-lh-heading-06);
      letter-spacing:var(--bh-ls-heading-06);
}

:host([site='BH']) .billboard-body-text, :host([site='BH']) .billboard-cta {
      font-size:var(--bh-fs-body-02);
      line-height:var(--bh-lh-body-02);
      letter-spacing:var(--bh-ls-body-02);
}

:host([site='BH']):host([billboardvariant='offset']) .billboard-content-section {
      font-size:var(--bh-fs-body-02);
      line-height:var(--bh-lh-body-02);
      letter-spacing:var(--bh-ls-body-02);
}

:host([site='BH']) :host([billboardvariant='feature']) .billboard-eyebrow {
      font-size:var(--bh-fs-body-01);
      line-height:var(--bh-lh-body-01);
      letter-spacing:var(--bh-ls-body-01);
}

:host([site='BH']) :host([billboardvariant='feature']) .billboard-headline {
      font-size:var(--bh-fs-heading-06);
      line-height:var(--bh-lh-heading-06);
      letter-spacing:var(--bh-ls-heading-06);
}

:host([site='BH']) :host([billboardvariant='feature']) .billboard-sub-headline {
      font-size:var(--bh-fs-heading-04);
      line-height:var(--bh-lh-heading-04);
      letter-spacing:var(--bh-ls-heading-04);
}

:host([site='BH']) :host([billboardvariant='feature']) .billboard-body-text {
      font-size:var(--bh-fs-body-02);
      line-height:var(--bh-lh-body-02);
      letter-spacing:var(--bh-ls-body-02);
}

:host([site='GHS']) .billboard-content-section, :host([site='GHS']) .billboard-body-text, :host([site='GHS']) .billboard-cta {
      font-family:var(--ff-body);
}

:host([site='GHS']) .billboard-headline, :host([site='GHS']) .billboard-sub-headline {
      font-family:var(--ff-display);
}

:host([site='GHS']) .billboard-headline {
      font-size:var(--fs-3xl);
      line-height:var(--lh-3xl);
}

@media (min-width: 1024px) {

      :host([site='GHS']) .billboard-headline {
            font-size:var(--fs-4xl);
            line-height:var(--lh-4xl);
      }
}

:host([site='GHS']) .billboard-sub-headline {
      font-size:var(--fs-xl);
      line-height:var(--lh-xl);
}

:host([site='GHS']) .billboard-body-text, :host([site='GHS']) .billboard-cta {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
}

:host([site='GHS']):host([billboardvariant='offset']) .billboard-content-section ::slotted(*) {
      font-family:var(--ff-body);
}

:host([site='GHS']):host([billboardvariant='offset']) .billboard-content-section ::slotted(*) {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
}

:host([site='GHS']) :host([billboardvariant='full']) .billboard-body-text ::slotted(*), :host([site='GHS']) :host([billboardvariant='full']) .billboard-cta ::slotted(*) {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
}

:host([site='GHS']) :host([billboardvariant='feature']) .billboard-eyebrow {
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
}

:host([site='GHS']) :host([billboardvariant='feature']) .billboard-headline {
      font-size:var(--fs-3xl);
      line-height:var(--lh-3xl);
}

@media (min-width: 1024px) {

      :host([site='GHS']) :host([billboardvariant='feature']) .billboard-headline {
            font-size:var(--fs-4xl);
            line-height:var(--lh-4xl);
      }
}

:host([site='GHS']) :host([billboardvariant='feature']) .billboard-sub-headline {
      font-size:var(--fs-2xl);
      line-height:var(--lh-2xl);
}

@media (min-width: 1024px) {

      :host([site='GHS']) :host([billboardvariant='feature']) .billboard-sub-headline {
            font-size:var(--fs-3xl);
            line-height:var(--lh-3xl);
      }
}

:host([site='GHS']) :host([billboardvariant='feature']) .billboard-body-text {
      font-size:var(--fs-base);
      line-height:var(--lh-base);
}

@media (min-width: 1024px) {

      :host([site='GHS']) :host([billboardvariant='feature']) .billboard-body-text {
            font-size:var(--fs-lg);
            line-height:var(--lh-lg);
      }
}

:host([colorvariant='emplify-white']) .billboard-content-section {
      background-color:var(--neutral-white);
}

:host([colorvariant='emplify-white']) .billboard-content-section {
      color:var(--eh-brand-primary);
}
`;